import { Phone, MessageCircle } from "lucide-react";
import { callLink, whatsappLink, SITE } from "../lib/constants";

export default function FloatingButtons() {
  return (
    <>
      {/* WhatsApp - bottom right (above emergent badge on mobile) */}
      <a
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed z-40 bottom-20 right-4 sm:bottom-6 sm:right-6 w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_12px_40px_-6px_rgba(37,211,102,0.55)] flex items-center justify-center hover:scale-110 active:scale-95 transition-transform"
        aria-label="WhatsApp Lotus Family Dental"
        data-testid="floating-whatsapp"
      >
        <MessageCircle className="w-6 h-6" fill="white" strokeWidth={0} />
        <span className="sr-only">{SITE.phone}</span>
        <span className="absolute -top-1 -right-1 w-3.5 h-3.5 bg-white rounded-full flex items-center justify-center">
          <span className="w-2 h-2 bg-[#25D366] rounded-full animate-pulse" />
        </span>
      </a>

      {/* Call - bottom left on mobile */}
      <a
        href={callLink}
        className="fixed z-40 bottom-20 left-4 sm:hidden w-14 h-14 rounded-full bg-teal-600 text-white shadow-[0_12px_40px_-6px_rgba(13,148,136,0.55)] flex items-center justify-center hover:scale-110 active:scale-95 transition-transform"
        aria-label="Call Lotus Family Dental"
        data-testid="floating-call"
      >
        <Phone className="w-5 h-5" />
      </a>
    </>
  );
}
